<template>
	<div>
		<el-row>
			<el-col :span="24" class="bread">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item v-if="$store.state.main.user.m_qaedas_id==0" :to="{ path: '/main' }">基地管理</el-breadcrumb-item>
					<el-breadcrumb-item :to="{ path: '/iot/terminal' }">终端管理</el-breadcrumb-item>
					<el-breadcrumb-item>消毒柜管理</el-breadcrumb-item>
				</el-breadcrumb>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="24">
				<div @click="choice(item)" class="card-dis" v-for="item in DisinfectionData" :key="item.id">
					<el-col :md="9" v-show="!$store.state.isphone">
						<el-col :span="24">
							<div class="img-div">
								<div class="img-state" :style="'background-color: '+(item.disinfectionOnLineStatus==1?'green;':'red;')">
									<i :class='item.disinfectionOnLineStatus==1?"el-icon-success":"el-icon-error"'></i>{{item.disinfectionOnLineStatus==1?"在线":"离线"}}
								</div>
								<img :src="config.apiurl+item.image" alt="">
								<div class="img-state2" style="color: green;">
									<i :class='item.disinfectionJobStatus==1?"my-icon-gzz":"my-icon-xxz"'></i>{{item.disinfectionJobStatus==1?"工作中":"休息中"}}
								</div>
								<div class="img-warn">{{item.exceedName}}</div>
							</div>
						</el-col>
					</el-col>
					<el-col :md="15">
						<!-- <el-col :span="24">
							<div class="dice">
								<div class="dice-title">
									功率
								</div>
								<div class="dice-content">
									{{item.a_phase}} W
								</div>
							</div>
							<div class="dice">
								<div class="dice-title">
									电流
								</div>
								<div class="dice-content">
									{{item.a_current}} A
								</div>
							</div>
							<div class="dice">
								<div class="dice-title">
									电压
								</div>
								<div class="dice-content">
									{{item.a_voltage}} V
								</div>
							</div>
							<div class="dice">
								<div class="dice-title">
									总电能
								</div>
								<div class="dice-content">
									{{item.ha_electric_energy}} W
								</div>
							</div>
						</el-col> -->
						<el-col :span="24" v-show="!$store.state.isphone">
							<br>
						</el-col>
						<el-col :span="24">
							<el-col :span="8" class="card-title">
								当前功率：
							</el-col>
							<el-col :span="16" class="card-content">
								{{item.a_phase}} W
							</el-col>
						</el-col>
						<el-col :span="24">
							<el-col :span="8" class="card-title">
								当前电流：
							</el-col>
							<el-col :span="16" class="card-content">
								{{item.a_current}} A
							</el-col>
						</el-col>
						<el-col :span="24">
							<el-col :span="8" class="card-title">
								当前电压：
							</el-col>
							<el-col :span="16" class="card-content">
								{{item.a_voltage}} V
							</el-col>
						</el-col>
						<el-col :span="24">
							<el-col :span="8" class="card-title">
								总用电能：
							</el-col>
							<el-col :span="16" class="card-content">
								{{item.ha_electric_energy}} kW·h
							</el-col>
						</el-col>
						<!-- <el-col :span="24" v-show="!$store.state.isphone">
							<br>
						</el-col> -->
						<!-- <el-col :span="24">
							<el-col :span="10" class="card-title">
								{{item.name}}
							</el-col>
							<el-col :span="14" class="card-content">
								<i :class='item.disinfectionOnLineStatus==1?"el-icon-success":"el-icon-error"'></i>{{item.disinfectionOnLineStatus==1?"在线":"离线"}}
							</el-col>
						</el-col>
						<el-col :span="24">
							<el-col :span="10" class="card-title">
								工作状态
							</el-col>
							<el-col :span="14" class="card-content">
								<i :class='item.disinfectionJobStatus==1?"el-icon-success":"el-icon-error"'></i>{{item.disinfectionJobStatus==1?"工作中":"未工作"}}
							</el-col>
						</el-col> -->
						<el-col :span="24">
							<el-col :span="8" class="card-title">
								供电方式：
							</el-col>
							<el-col :span="16" class="card-content">
								{{item.supply}}
							</el-col>
						</el-col>
						<el-col :span="24">
							<el-col :span="8" class="card-title">
								{{item.distanceDisinfectionName}}：
							</el-col>
							<el-col :span="16" class="card-content">
								<duration-time v-model="item.distanceDisinfectionValue" :control="false"></duration-time>
							</el-col>
						</el-col>
						<el-col :span="24">
							<el-col :span="8" class="card-title">
								{{item.distanceDisinfectionOnLineName}}：
							</el-col>
							<el-col :span="16" class="card-content">
								<duration-time v-model="item.distanceDisinfectionOnLineValue" :control="false"></duration-time>
							</el-col>
						</el-col>
						<!-- <el-col :span="24">
							<el-col :span="24" class="card-title-s">
								描述
							</el-col>
							<el-col :span="24" class="card-content-s">
								{{item.description}}
							</el-col>
						</el-col> -->
						<div class="card-time">采集时间：{{Totime(item.updateTime)}}</div>
					</el-col>
				</div>
			</el-col>
		</el-row>
		<el-row v-if="show">
			<el-col :span="24" v-if="DisinfectionData.length>0">
				<el-tabs type="border-card">
					<el-tab-pane label="消毒柜报警记录">
						<crud :fields="alarmlog" :select="[]" :limits="limits" apiU="Disinfectionalarmlog"></crud>
					</el-tab-pane>
					<el-tab-pane label="消毒柜日志">
						<crud :fields="log" :select="selectlog" :limits="limits" apiU="Disinfectionlog"></crud>
					</el-tab-pane>
					<el-tab-pane label="消毒柜功率">
						<crud :fields="powerlog" :select="[]" :limits="limits" apiU="Disinfectionpowerlog"></crud>
					</el-tab-pane>
				</el-tabs>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				DisinfectionData: [],
				show: true,
				timer: null,
				alarmlog: [{
						name: 'name',
						label: '名称',
						type: 'string',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'alarmStatus',
						label: '报警状态',
						type: 'select',
						selection: {
							prop: {
								label: 'label',
								value: 'value'
							},
							data: [{
									label: "超高功率报警",
									value: 1
								},
								{
									label: "电量不足报警",
									value: 2
								}
							]
						},
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'description',
						label: '描述',
						type: 'string',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'createTime',
						label: '时间',
						type: 'date',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					}
				],
				log: [{
						name: 'name',
						label: '名称',
						type: 'string',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'disinfectionStatus',
						label: '状态',
						type: 'select',
						selection: {
							prop: {
								label: 'label',
								value: 'value'
							},
							data: [{
									label: "在线",
									value: 1
								},
								{
									label: "离线",
									value: 2
								},
								{
									label: "工作中",
									value: 3
								},
								{
									label: "休息中",
									value: 4
								}
							]
						},
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'createTime',
						label: '时间',
						type: 'date',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'description',
						label: '描述',
						type: 'text',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					}
				],
				selectlog: [
					{
						name: 'disinfectionStatus',
						selection: {
							prop: {
								label: 'label',
								value: 'value'
							},
							data: [{
									label: "在线",
									value: 1
								},
								{
									label: "离线",
									value: 2
								},
								{
									label: "工作中",
									value: 3
								},
								{
									label: "未工作",
									value: 4
								}
							]
						}
					}
				],
				powerlog: [{
						name: 'name',
						label: '名称',
						type: 'string',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'a_phase',
						label: '一次侧A相有功功率',
						type: 'string',
						unit: "W",
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					// {
					// 	name: 'total_phase',
					// 	label: '一次侧总有功功率',
					// 	type: 'string',
					// 	unit: "W",
					// 	limits: {
					// 		look: true,
					// 		add: true,
					// 		edit: true,
					// 		table: true,
					// 		phone: true
					// 	}
					// },
					// {
					// 	name: 'atp',
					// 	label: '一次侧总视在功率',
					// 	type: 'string',
					// 	unit: "W",
					// 	limits: {
					// 		look: true,
					// 		add: true,
					// 		edit: true,
					// 		table: true,
					// 		phone: true
					// 	}
					// },
					{
						name: 'a_current',
						label: '一次侧A相电流',
						type: 'string',
						unit: "A",
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'a_voltage',
						label: '一次侧A相电压',
						type: 'string',
						unit: "V",
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'ha_electric_energy',
						label: '当前总有功电能',
						type: 'string',
						unit: "kW·h",
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					// {
					// 	name: 'not_electric_energy',
					// 	label: '当前总无功电能',
					// 	type: 'string',
					// 	unit: "W",
					// 	limits: {
					// 		look: true,
					// 		add: true,
					// 		edit: true,
					// 		table: true,
					// 		phone: true
					// 	}
					// },
					// {
					// 	name: 'a_atp',
					// 	label: 'A 相视在功率',
					// 	type: 'string',
					// 	unit: "W",
					// 	limits: {
					// 		look: true,
					// 		add: true,
					// 		edit: true,
					// 		table: true,
					// 		phone: true
					// 	}
					// },
					// {
					// 	name: 'a_total_atp',
					// 	label: '一次侧 A 总有功功率',
					// 	type: 'string',
					// 	unit: "W",
					// 	limits: {
					// 		look: true,
					// 		add: true,
					// 		edit: true,
					// 		table: true,
					// 		phone: true
					// 	}
					// },
					// {
					// 	name: 'a_not_phase',
					// 	label: 'A 相无功功率',
					// 	type: 'string',
					// 	unit: "W",
					// 	limits: {
					// 		look: true,
					// 		add: true,
					// 		edit: true,
					// 		table: true,
					// 		phone: true
					// 	}
					// },
					{
						name: 'createTime',
						label: '时间',
						type: 'date',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'description',
						label: '描述',
						type: 'text',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					}
				],
				limits: {
					add: false,
					delete: false,
					edit: false,
					find: true,
					export: true,
					look: true
				}
			}
		},
		methods: {
			load() {
				this.api.Disinfection.getList({
						terminalId: this.$route.query.id
					})
					.then((res) => {
						this.DisinfectionData = res.data.data.list;
						if (this.DisinfectionData.length > 0) {
							this.$router.push({
								path: '/iot/Disinfection',
								query: {
									Did: this.DisinfectionData[0].id,
									id: this.$route.query.id
								}
							});
						}
					})
			},
			choice(item) {
				this.show = false;
				this.$router.push({
					path: '/iot/Disinfection',
					query: {
						Did: item.id,
						id: this.$route.query.id
					}
				});
				setTimeout(() => {
					this.show = true;
				}, 10);

			}
		},
		filters: {

		},
		mounted() {
			this.load();
			clearInterval(this.timer);
			this.timer = setInterval(this.load, 5000); //刷新
		},
		beforeDestroy() {
			clearInterval(this.timer);
		},
		computed: {

		}
	}
</script>

<style scoped>
	.bread {
		margin: 15px 0px;
	}

	.card-dis {
		float: left;
		position: relative;
		width: 450px;
		height: 225px;
		margin-bottom: 15px;
		background-color: white;
		border-radius: 5px;
		margin-right: 10px;
		cursor: pointer;
	}

	.card-time {
		position: absolute;
		bottom: 2px;
		right: 0;
		width: 62.5%;
		font-size: 12px;
		text-align: center;
		/* padding-right: 1em; */
	}

	.img-warn {
		position: absolute;
		top: -1px;
		right: 0;
		width: 100%;
		text-align: center;
		color: red;
		font-size: 12px;
	}

	.card-dis img {
		border-radius: 5px 0 0 5px;
		width: 86%;
		height: 196px;
		margin: 7%;
		margin-bottom: 8%;
	}

	.img-div {
		position: relative;
		overflow: hidden;
	}

	.img-state {
		position: absolute;
		right: -35px;
		top: 5px;
		transform: rotate(45deg);
		background-color: gray;
		color: white;
		font-size: 12px;
		width: 100px;
		text-align: center;
	}

	.img-state2 {
		position: absolute;
		right: 0;
		bottom: 0;
		width: 100%;
		text-align: center;
	}

	.card-title {
		padding-left: 1em;
		color: #606266;
		font-size: 14px;
		line-height: 25px;
	}

	.card-content {
		color: #303133;
		line-height: 25px;
	}

	.card-title-s {
		padding-left: 1em;
		color: #606266;
		font-size: 12px;
	}

	.card-content-s {
		padding-left: 2em;
		color: #303133;
		line-height: 25px;
	}

	.dice {
		width: 24%;
		height: 70px;
		margin-right: 1%;
		/* border: 1px solid #409eff; */
		border-radius: 3px;
		text-align: center;
		background-color: #409eff;
		color: white;
		float: left;
	}

	.dice-title {
		font-size: 14px;
		margin-top: 5px;
	}

	.dice-content {
		margin-top: 10px;
		font-size: 20px;
	}

	@media screen and (min-width: 0px) and (max-width: 700px) {
		.bread {
			margin: 5px 0px;
		}

		.card-dis {
			width: 100%;
			height: 200px;
			margin-bottom: 5px;
		}

		.card-title {
			padding-left: 0em;
		}

		.card-title-s {
			padding-left: 0em;
		}

		.card-content-s {
			padding-left: 1em;
		}
	}
</style>
